/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type BlockAgentOnConnectionForm = {
  /**
   * The agent to block; any agent in the caller's organization
   */
  agentId: string;
  /**
   * The upstream OAuth client of the caller's own connection
   */
  remoteSessionClientId: string;
};

/** @internal */
export type BlockAgentOnConnectionForm$Outbound = {
  agent_id: string;
  remote_session_client_id: string;
};

/** @internal */
export const BlockAgentOnConnectionForm$outboundSchema: z.ZodMiniType<
  BlockAgentOnConnectionForm$Outbound,
  BlockAgentOnConnectionForm
> = z.pipe(
  z.object({
    agentId: z.string(),
    remoteSessionClientId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      remoteSessionClientId: "remote_session_client_id",
    });
  }),
);

export function blockAgentOnConnectionFormToJSON(
  blockAgentOnConnectionForm: BlockAgentOnConnectionForm,
): string {
  return JSON.stringify(
    BlockAgentOnConnectionForm$outboundSchema.parse(blockAgentOnConnectionForm),
  );
}
